import { IDepartmentViewModel } from 'Interfaces/ICompaniesConfig';
import { isEmptyObject } from 'functions/isEmpotyObject';
import { rq } from 'http/apiRoutes';
import { useGet } from 'http/useApi';
import { DepartmentForm } from 'pages/Companies/DepartmentForm';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

export const Department = () => {
  const { companyId, departmentId } = useParams();
  // STATES
  const [department, setDepartment] = useState<IDepartmentViewModel>(
    {} as IDepartmentViewModel
  );

  //const [departments, setDepartments] = useState<IDepartmentViewModel[]>([]);

  // api

  let isEnabled =
    !isEmptyObject(department) && companyId !== 'new' ? true : false;
  // console.log('isEnabled', isEnabled, !isEmptyObject(departments), companyId);
  // console.log('companyId',(isEmptyObject(departments) && companyId !== 'new'));

  const { data: departmentData } = useGet(
    rq.department(companyId || '', departmentId || '', isEnabled),
    
  );

  /*   let employeeId = 'new';
  let resourceId = 'new';
  let objectDrawerList: objectArray[] = useGetObjectList(
    companyId ?? 'new',
    employeeId ?? 'new',
    departmentId ?? 'new',
    resourceId ?? 'new',
    isObjectList
  ); */

  useEffect(() => {
    if (departmentData !== null) {
      setDepartment(departmentData);
    }
  }, [departmentData]);

  /*   useEffect(() => { */
  // update objectList
  /*   if (employeeData !== null) {
      let _companyEmployees = _.cloneDeep(employeeData?.allEmployees || []);
      setEmployees(_companyEmployees);
      objectDrawerList[EnumObjectType.CompanyEmployees].objectList = _companyEmployees;
    } */

  // set selected Resource
  /*   if (departmentId === 'new') {
        setDepartment(initialState);
      } else {
      let tmp = _.cloneDeep(departmentData);  
      setDepartment(tmp);
    } */

  // set departmens
  /*  if (departmentsData !== null) {
      let tmp = _.cloneDeep(departmentsData?.departments);
      setDepartments(tmp);
      objectDrawerList[EnumObjectType.Department].objectList = tmp;
    } */

  /*   if (departmentsData !== null && employeeData !== null && departmentsData !== null) {
      setIsObjectList(true);
    } else {
      setIsObjectList(false);
    } */
  /*  }, [departmentsData]); */

  //console.log("Department", departmentId, companyId);

  const { data: company } = useGet(rq.company(companyId, true), );

  if (department === null || department === undefined) {
    return <div>loading...</div>;
  }
  return <DepartmentForm department={department} company={company} />;
};
